const TRACKING_ENDPOINT = 'https://geo.teddymobile.cn/api/link-analysis/events';
const VISITOR_ID_KEY = 'laolao_link_analysis_visitor_id';

let pageViewReported = false;

function getTrackingCode() {
  return new URLSearchParams(window.location.search).get('sl');
}

function createUuid() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.random() * 16 | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

function getVisitorId() {
  try {
    const savedVisitorId = window.localStorage.getItem(VISITOR_ID_KEY);
    if (savedVisitorId) {
      return savedVisitorId;
    }

    const visitorId = createUuid();
    window.localStorage.setItem(VISITOR_ID_KEY, visitorId);
    return visitorId;
  } catch (error) {
    return createUuid();
  }
}

function buildPayload(eventType, sl) {
  return {
    sl,
    event_type: eventType,
    visitor_id: getVisitorId(),
    event_id: createUuid(),
    page_url: window.location.href,
    referrer: document.referrer || '',
  };
}

export function reportTrackingEvent(eventType) {
  const sl = getTrackingCode();
  if (!sl) {
    return;
  }

  const payload = buildPayload(eventType, sl);
  const payloadText = JSON.stringify(payload);

  console.log('埋点请求:', {
    url: TRACKING_ENDPOINT,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
  });

  fetch(TRACKING_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payloadText,
    keepalive: true,
  }).then(async (response) => {
    const responseText = await response.text();

    console.log('埋点响应:', {
      status: response.status,
      statusText: response.statusText,
      ok: response.ok,
      body: responseText,
    });
  }).catch((error) => {
    console.error('埋点上报失败:', error);
  });
}

export function reportPageView() {
  if (pageViewReported) {
    return;
  }

  pageViewReported = true;
  reportTrackingEvent('click');
}
